module.exports = __webpack_public_path__ + "img/certificate4.a4e5de0c.png";